// extracted by mini-css-extract-plugin
module.exports = {"base":"BurgerIcon_base__1v4gv"};
    if(module.hot) {
      // 1586964020981
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  